import { render, staticRenderFns } from "./rename-defend.vue?vue&type=template&id=a5ca0b58"
import script from "./rename-defend.vue?vue&type=script&lang=js"
export * from "./rename-defend.vue?vue&type=script&lang=js"
import style0 from "./rename-defend.vue?vue&type=style&index=0&id=a5ca0b58&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports